import React, { Component } from "react";
import styled from "styled-components";
import Chart from "react-apexcharts";
import CircularProgress from "@material-ui/core/CircularProgress";

export default class ChartLine extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showLoading: this.props.showLoading || false,
      options_line: {
        chart: {
          id: "linechart",
          animations: {
            enabled: true,
            easing: "easeinout",
            speed: 800,
            dynamicAnimation: {
              enabled: true,
              speed: 350,
            },
          },
          toolbar: {
            show: this.props.showControls,
            offsetX: 0,
            offsetY: 0,
            tools: {
              download: true,
              selection: true,
              zoom: true,
              zoomin: true,
              zoomout: true,
              pan: true,
              reset: true,
            },
            autoSelected: "zoom",
          },
          zoom: {
            autoScaleYaxis: true,
          },
        },
        dataLabels: {
          enabled: false,
        },
        stroke: {
          curve: "straight",
          width: 4,
        },
        title: {
          text: this.props.title,
          align: "left",
          style: {
            fontSize: "16px",
          },
        },
        grid: {
          row: {
            colors: ["transparent"], // takes an array which will be repeated on columns
            opacity: 0.5,
          },
        },
        xaxis: {
          categories: this.props.timeline,
        },
      },
      options_bar: {
        chart: {
          animations: {
            enabled: true,
            easing: "easeinout",
            speed: 800,
            animateGradually: {
              enabled: true,
              delay: 150,
            },
            dynamicAnimation: {
              enabled: true,
              speed: 350,
            },
          },
          toolbar: {
            show: this.props.showControls,
            offsetX: 0,
            offsetY: 0,
            tools: {
              download: true,
              selection: true,
              zoom: true,
              zoomin: true,
              zoomout: true,
              pan: true,
              reset: true,
            },
            autoSelected: "zoom",
          },
        },
        dataLabels: {
          enabled: false,
        },
        stroke: {
          curve: "straight",
        },
        title: {
          text: this.props.title,
          align: "left",
          style: {
            fontSize: "16px",
          },
        },
        grid: {
          row: {
            colors: ["transparent"], // takes an array which will be repeated on columns
            opacity: 0.5,
          },
        },
        xaxis: {
          categories: this.props.timeline,
        },
      },
      options_radialBar: {
        chart: {
          type: "radialBar",
          height: 50,
        },
        plotOptions: {
          radialBar: {
            hollow: {
              size: "48%",
            },
            dataLabels: {
              name: {
                fontSize: "14px",
              },
              value: {
                fontSize: "12px",
              },
              total: {
                show: false,
              },
            },
          },
        },
        title: {
          text: this.props.title,
          align: "left",
          style: {
            fontSize: "16px",
          },
        },
        labels: this.props.data.map((item) => {
          return item.name;
        }),
        legend: {
          show: true,
          position: "left",
          offsetX: -20,
          offsetY: 40,
          formatter: function (val, opts) {
            return val + " - " + opts.w.globals.series[opts.seriesIndex] + "%";
          },
        },
      },
      options_pie: {
        chart: {
          type: "pie",
          height: 50,
        },
        title: {
          text: this.props.title,
          align: "left",
          style: {
            fontSize: "16px",
          },
        },
        labels: this.props.data.map((item) => {
          return item.name;
        }),
        legend: {
          show: true,
          position: "left",
          offsetX: -20,
          offsetY: 40,
        },
      },
      selection: "one_month",
      analytic: this.props.analytic,
    };
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      showLoading: nextProps.showLoading,
      data: nextProps.data,
      timeline: nextProps.timeline,
    });
  }

  updateData(timeline) {
    this.setState({
      selection: timeline,
    });
    this.props.filterChart(this.state.analytic, timeline);

    /* switch (timeline) {
        case 'one_month':
          ApexCharts.exec(
            'linechart',
            'zoomX',
            new Date(new Date().setMonth(new Date().getMonth() - 1)).getTime(),
            new Date().getTime()
          )
          break
        case 'six_months':
          ApexCharts.exec(
            'linechart',
            'zoomX',
            new Date(new Date().setMonth(new Date().getMonth() - 6)).getTime(),
            new Date().getTime()
          )
          break
        case 'one_year':
          ApexCharts.exec(
            'linechart',
            'zoomX',
            new Date( new Date().setMonth(new Date().getMonth() - 12)).getTime(),
            new Date().getTime()
          )
          break
        case 'all':
          ApexCharts.exec(
            'linechart',
            'zoomX',
            new Date('1 Jan 1999').getTime(),
            new Date().getTime()
          )
          break
        default:
      } */
  }

  render() {
    const data =
      this.props.type === "radialBar" || this.props.type === "pie"
        ? this.props.data
            .map((item) => {
              return item.data;
            })
            .flat(Infinity)
        : this.props.data;
    const type = this.props.type;
    const options = this.state[`options_${this.props.type}`];
    if (options.xaxis) options.xaxis.categories = this.props.timeline;
    const { showLoading } = this.state;
    return (
      <>
        <div>
          {showLoading && (
            <LoadingContainerChart hidden={!this.state.showLoading}>
              <CircularProgress color="primary" />
            </LoadingContainerChart>
          )}

          {!showLoading && (
            <>
              {this.props.showControls && (
                <ChartFilter className="toolbar">
                  <button
                    id="one_month"
                    onClick={() => this.updateData("one_month")}
                    className={
                      this.state.selection === "one_month" ? "active" : ""
                    }
                  >
                    1M
                  </button>
                  <button
                    id="six_months"
                    onClick={() => this.updateData("six_months")}
                    className={
                      this.state.selection === "six_months" ? "active" : ""
                    }
                  >
                    6M
                  </button>
                  <button
                    id="one_year"
                    onClick={() => this.updateData("one_year")}
                    className={
                      this.state.selection === "one_year" ? "active" : ""
                    }
                  >
                    1Y
                  </button>
                  <button
                    id="all"
                    onClick={() => this.updateData("all")}
                    className={this.state.selection === "all" ? "active" : ""}
                  >
                    ALL
                  </button>
                </ChartFilter>
              )}

              <Chart
                options={options}
                series={data}
                type={type}
                height={this.props.height}
              />
            </>
          )}
        </div>
      </>
    );
  }
}

//CSS
const ChartFilter = styled.div`
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  justify-content: flex-end;
  margin-bottom: 10px;
  > button {
    padding: 0 10px;
    background: white;
    border: 2px solid #0d334c;
    border-radius: 5px;
    margin-left: 10px;
    font-size: 12px;
    color: #0d334c;
    outline: none;

    &.active {
      background: #0d334c;
      color: white;
    }
  }
`;

const LoadingContainerChart = styled.section`
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  position: absolute;
  background-color: white;
  z-index: 20;
  display: flex;
  justify-content: center;
  align-items: center;
`;
